module.exports = __webpack_public_path__ + "img/核心技术--人脸检测.11495ab7.png";